import { loadExtensionRelease, type ExtensionReleaseCache, type ExtensionReleaseResult } from '@erp/shared'

const CACHE_KEY = 'extension.release.metadata.v1'

export function getSellerExtensionRelease(): Promise<ExtensionReleaseResult> {
  return loadExtensionRelease({
    trustedOrigin: window.location.origin,
    readCache: async () => {
      const value = localStorage.getItem(CACHE_KEY)
      return value ? JSON.parse(value) as ExtensionReleaseCache : null
    },
    writeCache: async (cache) => localStorage.setItem(CACHE_KEY, JSON.stringify(cache)),
  })
}

export type { ExtensionReleaseResult }
